<template>
    <div id="AccountSettings">
        <h1>AccountSettings</h1>
    </div>
</template>

<script>
    export default {
        name: 'AccountSettings'
    }
</script>
